import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getFileExtension, toBase64 } from '../../utils/util';

import {
  requestVerifyUser,
  requestDeleteVerificationDocument,
  requestUploadVerificationDocument,
  requestAddBrokerRole,
} from '../../api/verification/verification.actions';

import Verification from '../../components/screens/verification/Verification';

const VerificationContainer = () => {
  const { userVerification } = useSelector(({ party }) => party);

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(requestVerifyUser({}));
  }, [dispatch]);

  const addBrokerRole = () => {
    dispatch(requestAddBrokerRole({ onSuccess: () => dispatch(requestVerifyUser({})) }));
  };

  const uploadVerificationDocument = async (file, documentSubject, documentCategory) => {
    const documentBase64 = await toBase64(file);
    const documentType = getFileExtension(file.name);

    const verificationDocument = {
      name: file.name,
      documentExtension: documentType,
      base64EncodedString: documentBase64,
      documentSubject,
      category: documentCategory,
    };

    dispatch(
      requestUploadVerificationDocument({ verificationDocument, onSuccess: () => dispatch(requestVerifyUser()) })
    );
  };

  const deleteVerificationDocument = (documentSubject) => {
    dispatch(requestDeleteVerificationDocument({ documentSubject, onSuccess: () => dispatch(requestVerifyUser()) }));
  };

  if (!userVerification) {
    return;
  }

  return (
    <Verification
      userVerification={userVerification}
      uploadVerificationDocument={uploadVerificationDocument}
      deleteVerificationDocument={deleteVerificationDocument}
      addBrokerRole={addBrokerRole}
    />
  );
};

export default VerificationContainer;
